import type { DataGridProProps } from '@mui/x-data-grid-pro';
import type { TableColumnDTO } from '@tempo-io/roadmap-dto';
import { parseTableColumnField } from './tableColumnUtils';

export type OnColumnWidthChange = (columns: TableColumnDTO[]) => void;

export const useOnColumnWidthChange = (
  columns: TableColumnDTO[],
  onColumnWidthChange?: OnColumnWidthChange,
) => {
  if (!onColumnWidthChange) return undefined;

  const onItemsTableColumnWidthChange: DataGridProProps['onColumnWidthChange'] = ({
    colDef,
    width,
  }) => {
    if (!colDef.resizable) return;

    const updatedColumn: TableColumnDTO = { ...parseTableColumnField(colDef.field), width };
    const resizedColumnIndex = columns.findIndex(
      (column) =>
        column.type === updatedColumn.type && column.customFieldId === updatedColumn.customFieldId,
    );

    if (resizedColumnIndex === -1) {
      onColumnWidthChange([...columns, updatedColumn]);
      return;
    }

    if (columns[resizedColumnIndex] && columns[resizedColumnIndex].width !== width) {
      const resizedColumns = [...columns];
      resizedColumns[resizedColumnIndex] = updatedColumn;
      onColumnWidthChange(resizedColumns);
    }
  };

  return onItemsTableColumnWidthChange;
};
